// extracted by mini-css-extract-plugin
var _1 = "MainOfficeContainer__bg--ZlZTn TopGeneral__bg--z7KIw TopGeneral__bgSize--LtApb";
var _2 = "MainOfficeContainer__bgArgyle--STJsG TopGeneral__bgWhite--geQaF TopGeneral__bg--z7KIw TopGeneral__bgSize--LtApb";
var _3 = "MainOfficeContainer__container--pCZAI";
var _4 = "MainOfficeContainer__containerInner--EspyI MainOfficeContainer__container--pCZAI";
var _5 = "MainOfficeContainer__content--JFuSJ";
var _6 = "MainOfficeContainer__loading--eQMCP";
var _7 = "MainOfficeContainer__main--xBEIS CoreGeneral__roboto--UlmjE";
var _8 = "MainOfficeContainer__minContainer--JPOzs MainOfficeContainer__container--pCZAI";
export { _1 as "bg", _2 as "bgArgyle", _3 as "container", _4 as "containerInner", _5 as "content", _6 as "loading", _7 as "main", _8 as "minContainer" }
